import styled from 'styled-components';
import Select from 'react-select';
import { themedSelectMenuCss } from '../../theme/selectStyles';

export const StyledOpenFilterButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 26px;
  border-left: 1px solid ${({ theme }) => theme.border};
  background: transparent;
  padding: 3px 0;
  svg,
  svg path {
    fill: ${({ theme }) => theme.text};
    stroke: ${({ theme }) => theme.text};
  }
`;

export const StyledOpenFilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  background-color: ${({ theme }) => theme.card};
  width: 120px;
  margin-left: auto;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.border};
  cursor: pointer;
  position: sticky;
  top: 8px;
  z-index: 6;
  > span {
    margin: 0 18px;
    font-family: 'Archivo', sans-serif;
    font-size: 12px;
    line-height: 26px;
    font-weight: 500;
    color: ${({ theme }) => theme.text};
  }
`;

export const StyledSelectContainer = styled.div`
  width: 420px;
  position: absolute;
  right: 0;
  margin: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 5;
  @media screen and (min-width: 992px) and (max-width: 1204px) {
    flex: none;
    width: 100%;
  }
  @media only screen and (max-width: 991px) {
    flex-direction: row;
    position: relative;
    width: 100%;
    display: flex;
  }
  @media only screen and (max-width: 575px) {
    flex-direction: column;
    position: relative;
    width: 100%;
    display: flex;
  }
  > input {
    border: none;
  }
`;

export const StyledSelect = styled(Select)`
  width: 165px;
  margin-right: 5px;
  margin-left: 5px;
  &:last-of-type {
    margin-right: 0;
  }
  &:first-of-type {
    margin-left: 0;
  }
  @media only screen and (max-width: 575px) {
    width: 100%;
    margin-bottom: 5px;
  }
  @media only screen and (min-width: 576px) and (max-width: 768px) {
    width: 120px;
  }
  @media only screen and (min-width: 769px) and (max-width: 991px) {
    width: 33%;
  }
  .react-select__control {
    background: ${({ theme }) => theme.card};
    color: ${({ theme }) => theme.text};
    border: 1px solid ${({ theme }) => theme.border};
    box-shadow: none;
    min-height: 36px;
  }
  .react-select__single-value,
  .react-select__input-container {
    color: ${({ theme }) => theme.text};
  }
  .react-select__indicator-separator {
    display: none;
  }

  .react-select__placeholder {
    font-family: 'Archivo', sans-serif;
    font-size: 14.222px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.textFaint};
  }
  ${themedSelectMenuCss}
`;

export const StyledFilterBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
`;

export const StyledWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  @media only screen and (max-width: 991px) {
    width: 100%;
    max-width: 100%;
  }
`;
